/**
 * 定义store部分模块常量，便于全局引用
 */
export const StoreModuleName = {
  ENVIRONMENT: 'environment',
};
